export default __webpack_public_path__ + "static/media/no_triggers.67ea1fdd.svg";